import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/wifi alert.svg` */
export const WifiAlertIcon = createTripletGlyphIcon('WifiAlertIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00025 11.8838C8.44193 11.8839 8.79998 12.2419 8.80006 12.6836C8.80006 13.1253 8.44198 13.4833 8.00025 13.4834C7.55842 13.4834 7.20045 13.1254 7.20045 12.6836C7.20052 12.2418 7.55847 11.8838 8.00025 11.8838Z"
        fill="currentColor"
      />
      <path
        d="M6.40162 9.26465C6.40061 9.42625 6.41164 9.58939 6.42994 9.75C5.90378 9.957 5.46659 10.2252 5.17506 10.4609C4.96048 10.6344 4.64564 10.6011 4.47193 10.3867C4.29832 10.1721 4.33158 9.85728 4.54615 9.68359C4.97185 9.3393 5.62104 8.9532 6.40162 8.69727V9.26465Z"
        fill="currentColor"
      />
      <path
        d="M9.60084 8.63184C10.2278 8.8282 10.8609 9.16614 11.469 9.69531C11.6765 9.87648 11.6983 10.1923 11.5178 10.4004C11.3366 10.6085 11.0201 10.6302 10.8118 10.4492C10.4063 10.0964 9.99153 9.84867 9.57935 9.68359C9.59213 9.55131 9.60083 9.41966 9.60084 9.29102V8.63184Z"
        fill="currentColor"
      />
      <path
        d="M8.00025 2.43945C8.30373 2.43961 8.54982 2.6858 8.55006 2.98926V9.88965C8.55006 10.1933 8.30388 10.4393 8.00025 10.4395C7.6965 10.4395 7.45045 10.1934 7.45045 9.88965V2.98926C7.45068 2.6857 7.69664 2.43945 8.00025 2.43945Z"
        fill="currentColor"
      />
      <path
        d="M6.40162 6.6582C5.12481 6.9885 4.05615 7.60331 3.41236 8.12402C3.19787 8.29743 2.88298 8.26395 2.70924 8.0498C2.53564 7.83517 2.56892 7.52038 2.78346 7.34668C3.56622 6.71352 4.85871 5.98166 6.40162 5.62988V6.6582Z"
        fill="currentColor"
      />
      <path
        d="M9.60084 5.5498C10.8069 5.77814 12.049 6.32831 13.2327 7.3584C13.4401 7.53963 13.4621 7.85541 13.2815 8.06348C13.1004 8.27147 12.7847 8.29293 12.5764 8.1123C11.5994 7.26208 10.5876 6.78651 9.60084 6.56836V5.5498Z"
        fill="currentColor"
      />
      <path
        d="M6.56666 2.47461C6.45762 2.80837 6.40906 3.17569 6.40357 3.52344C4.51485 3.91214 2.92137 4.80591 1.99439 5.55566C1.77987 5.72904 1.46497 5.69566 1.29127 5.48145C1.11788 5.26684 1.15109 4.95197 1.36549 4.77832C2.4588 3.894 4.34037 2.85431 6.56666 2.47461Z"
        fill="currentColor"
      />
      <path
        d="M9.4065 2.39355C11.1328 2.59832 12.9384 3.29901 14.6506 4.78906C14.8585 4.97014 14.8799 5.28687 14.6995 5.49512C14.5182 5.70327 14.2017 5.725 13.9934 5.54395C12.5491 4.28707 11.0451 3.65326 9.59498 3.42578C9.58215 3.10112 9.53291 2.76362 9.42994 2.45605L9.4065 2.39355Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.00021 13.3691C9.50911 13.3691 9.92209 13.7821 9.92209 14.291C9.92186 14.7997 9.50897 15.2119 9.00021 15.2119C8.49146 15.2119 8.07857 14.7997 8.07834 14.291C8.07834 13.7821 8.49131 13.3691 9.00021 13.3691Z"
        fill="currentColor"
      />
      <path
        d="M7.32541 10.4922C7.32456 10.6322 7.3308 10.7734 7.34299 10.9131C6.69796 11.1514 6.16252 11.4768 5.81271 11.7598C5.57675 11.9501 5.23026 11.9132 5.03928 11.6777C4.8487 11.4417 4.88557 11.0953 5.12131 10.9043C5.62096 10.5001 6.39476 10.0431 7.32541 9.75684V10.4922Z"
        fill="currentColor"
      />
      <path
        d="M10.675 9.68555C11.4184 9.89928 12.1709 10.2889 12.8928 10.917C13.1215 11.1165 13.1458 11.4644 12.9465 11.6934C12.7472 11.9216 12.4 11.9455 12.1711 11.7471C11.6749 11.3153 11.1664 11.0238 10.6623 10.8389C10.6698 10.7319 10.675 10.6253 10.675 10.5205V9.68555Z"
        fill="currentColor"
      />
      <path
        d="M9.00021 2.68652C9.30397 2.68653 9.55002 2.93257 9.55002 3.23633V11.1367C9.54978 11.4403 9.30382 11.6865 9.00021 11.6865C8.6966 11.6865 8.45065 11.4403 8.45041 11.1367V3.23633C8.45041 2.93257 8.69646 2.68652 9.00021 2.68652Z"
        fill="currentColor"
      />
      <path
        d="M10.675 6.23242C12.0687 6.47377 13.5079 7.09463 14.8781 8.28711C15.1066 8.48642 15.1306 8.8345 14.9319 9.06348C14.7325 9.29215 14.3845 9.31605 14.1555 9.11719C13.0124 8.12248 11.8274 7.58204 10.675 7.34961V6.23242Z"
        fill="currentColor"
      />
      <path
        d="M7.32541 7.44629C5.83083 7.80977 4.57698 8.5259 3.83029 9.12988C3.59432 9.32047 3.2479 9.28343 3.05686 9.04785C2.86622 8.8118 2.9031 8.46541 3.13889 8.27441C4.03862 7.5467 5.53834 6.7012 7.32541 6.31738V7.44629Z"
        fill="currentColor"
      />
      <path
        d="M10.4231 2.68652C12.4104 2.89166 14.4963 3.67838 16.4729 5.39844C16.7015 5.59785 16.7256 5.94584 16.5266 6.1748C16.3273 6.4035 15.9792 6.42742 15.7502 6.22852C14.0794 4.77451 12.3376 4.06305 10.6633 3.8252C10.6399 3.44323 10.5704 3.05264 10.4348 2.71094C10.4315 2.70271 10.4265 2.69482 10.4231 2.68652Z"
        fill="currentColor"
      />
      <path
        d="M7.54221 2.77344C7.41057 3.13045 7.34754 3.5351 7.33225 3.92578C5.1472 4.34832 3.30005 5.3792 2.23459 6.24121C1.99862 6.43181 1.6522 6.39476 1.46115 6.15918C1.27065 5.92313 1.30744 5.5767 1.54318 5.38574C2.79656 4.3718 4.97315 3.17771 7.54221 2.77344Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.513 17.8252C13.2424 17.8253 13.8333 18.4171 13.8333 19.1465C13.8332 19.8757 13.2423 20.4667 12.513 20.4668C11.7837 20.4668 11.1929 19.8758 11.1927 19.1465C11.1927 18.4171 11.7836 17.8252 12.513 17.8252Z"
        fill="currentColor"
      />
      <path
        d="M14.763 13.0713C15.5838 13.3769 16.4075 13.8502 17.2025 14.542C17.5145 14.8137 17.5468 15.2882 17.2757 15.6006C17.0039 15.9126 16.5305 15.9451 16.2181 15.6738C15.7234 15.2434 15.2194 14.9177 14.7162 14.6777C14.7477 14.4298 14.763 14.18 14.763 13.9375V13.0713Z"
        fill="currentColor"
      />
      <path
        d="M10.263 13.8994C10.262 14.0672 10.2675 14.2366 10.2806 14.4043C9.20734 14.722 8.31222 15.2456 7.76206 15.6904C7.44009 15.9509 6.96793 15.901 6.70737 15.5791C6.44725 15.2571 6.49683 14.7848 6.8187 14.5244C7.57408 13.9135 8.79812 13.2148 10.263 12.8555V13.8994Z"
        fill="currentColor"
      />
      <path
        d="M12.513 3.65918C12.9271 3.65924 13.2628 3.99517 13.263 4.40918V14.9092C13.263 15.3234 12.9272 15.6591 12.513 15.6592C12.0988 15.6592 11.763 15.3234 11.763 14.9092V4.40918C11.7632 3.99513 12.0989 3.65918 12.513 3.65918Z"
        fill="currentColor"
      />
      <path
        d="M14.763 8.39551C16.4577 8.77619 18.1906 9.59382 19.848 11.0361C20.16 11.3079 20.1925 11.7823 19.9212 12.0947C19.6494 12.4071 19.1751 12.4397 18.8626 12.168C17.5168 10.9969 16.1271 10.3001 14.763 9.94043V8.39551Z"
        fill="currentColor"
      />
      <path
        d="M10.263 9.83789C8.05713 10.274 6.19236 11.3161 5.11753 12.1855C4.79564 12.4458 4.32338 12.3958 4.06284 12.0742C3.8026 11.7523 3.8524 11.28 4.17417 11.0195C5.4585 9.98061 7.65774 8.76345 10.263 8.31055V9.83789Z"
        fill="currentColor"
      />
      <path
        d="M14.4779 3.63672C16.9548 3.99764 19.528 5.05512 21.9749 7.18457C22.2868 7.45638 22.3194 7.93085 22.0482 8.24316C21.7763 8.55542 21.302 8.58805 20.9896 8.31641C18.9446 6.5368 16.8202 5.59064 14.7591 5.20312C14.7432 4.67487 14.6557 4.12455 14.4779 3.63672Z"
        fill="currentColor"
      />
      <path
        d="M10.558 3.60742C10.3773 4.09043 10.2863 4.63725 10.2669 5.16406C7.14526 5.65965 4.48804 7.12169 2.99057 8.33301C2.66861 8.5935 2.19645 8.54355 1.93588 8.22168C1.6758 7.89967 1.72536 7.42739 2.04721 7.16699C3.77443 5.7698 6.81341 4.11293 10.3871 3.62793C10.4437 3.62025 10.501 3.61451 10.558 3.60742Z"
        fill="currentColor"
      />
    </svg>
  ),
});
